import { Avatar, Badge } from "../../components/design";
import useTranslator from "../../hooks/useTranslator";
import styles from "./ApplicationPeopleSummary.module.css";

export type ApplicationMember = {
  name: string;
  email?: string;
  role: "tenant" | "guarantor";
  status?: "invitationSent" | "pendingProfile";
};

type Props = {
  members?: ApplicationMember[];
};

export default function ApplicationPeopleSummary({ members = [] }: Props) {
  const { _t } = useTranslator();

  if (members.length === 0) return null;

  return (
    <div
      className={styles.people}
      aria-label={_t("applicationMembers", "Application members")}
    >
      {members.map((member, index) => (
        <div
          className={styles.person}
          key={`${member.role}-${member.email || member.name}-${index}`}
          title={member.email}
        >
          <Avatar name={member.name.trim() || "?"} size="sm" />
          <span className={styles.name}>{member.name}</span>
          <Badge tone="neutral">
            {_t(member.role === "guarantor" ? "guarantor" : "tenant")}
          </Badge>
          {member.role === "guarantor" && member.status && (
            <Badge
              tone={member.status === "invitationSent" ? "lime" : "warning"}
            >
              {member.status === "invitationSent"
                ? _t("invitationSent", "Invitation sent")
                : _t("pendingProfile", "Pending profile")}
            </Badge>
          )}
        </div>
      ))}
    </div>
  );
}
